(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["diya-pouch-offer"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('diya-gift-offer')) {
  class DiyaGiftOffer extends HTMLElement {
    static pendingCart = null;
    static adding = false;
    static getCart() {
      if (!this.pendingCart) {
        this.pendingCart = fetch(window.Shopify.routes.root + 'cart.js', { cache: 'no-store' })
          .then(response => { if (!response.ok) throw new Error('Cart unavailable'); return response.json(); })
          .finally(() => { this.pendingCart = null; });
      }
      return this.pendingCart;
    }
    connectedCallback() {
      this.bagIds = new Set(this.dataset.bagIds.split(','));
      this.addonIds = new Set(this.dataset.addonIds.split(','));
      this.typeSelect = this.querySelector('[data-offer-type]');
      this.select = this.querySelector('[data-offer-product]');
      this.button = this.querySelector('[type="submit"]');
      this.error = this.querySelector('[role="alert"]');
      this.catalog = Array.from(this.querySelector('[data-offer-catalog]').content.querySelectorAll('option'));
      for (const option of Array.from(this.typeSelect.options)) {
        if (!this.catalog.some(item => item.dataset.kind === option.value)) option.remove();
      }
      if (!this.typeSelect.options.length) return;
      this.form = this.querySelector('form');
      this.submitHandler = event => this.add(event);
      this.typeHandler = () => { this.choiceMade = false; this.fillChoices(); };
      this.choiceHandler = () => { this.choiceMade = true; this.updateDisplay(); };
      this.form.addEventListener('submit', this.submitHandler);
      this.typeSelect.addEventListener('change', this.typeHandler);
      this.select.addEventListener('change', this.choiceHandler);
      if (typeof subscribe === 'function') this.unsubscribe = subscribe(PUB_SUB_EVENTS.cartUpdate, () => this.refresh());
      this.fillChoices();
      this.refresh();
    }
    disconnectedCallback() {
      this.unsubscribe?.();
      this.form?.removeEventListener('submit', this.submitHandler);
      this.typeSelect?.removeEventListener('change', this.typeHandler);
      this.select?.removeEventListener('change', this.choiceHandler);
    }
    money(cents) {
      return new Intl.NumberFormat(document.documentElement.lang || 'en-IE', {
        style: 'currency', currency: 'EUR', minimumFractionDigits: cents % 100 === 0 ? 0 : 2, maximumFractionDigits: 2
      }).format(cents / 100);
    }
    inspect(cart) {
      const bags = cart.items.filter(item => this.bagIds.has(String(item.product_id)));
      return {
        bag: bags[0],
        count: bags.reduce((n, item) => n + item.quantity, 0),
        addon: cart.items.some(item => this.addonIds.has(String(item.product_id)))
      };
    }
    fillChoices() {
      const choices = this.catalog.filter(item => item.dataset.kind === this.typeSelect.value)
        .sort((a, b) => Number(a.dataset.price) - Number(b.dataset.price) || a.textContent.localeCompare(b.textContent));
      this.select.replaceChildren(...choices.map(item => item.cloneNode(true)));
      this.matchPrint();
      this.updateDisplay();
    }
    matchPrint() {
      if (this.choiceMade || !this.cart) return;
      const bag = this.inspect(this.cart).bag;
      const title = (bag?.product_title || document.querySelector('h1')?.textContent || '').toLowerCase();
      const print = title.replace(/\s+(laptop tote(?: bag)?|shoulder bag)$/i, '').trim();
      const matching = Array.from(this.select.options).find(option => print.length > 2 && option.dataset.title.toLowerCase().startsWith(print));
      if (matching) this.select.value = matching.value;
    }
    updateDisplay() {
      const option = this.select.selectedOptions[0];
      if (!option) { this.hidden = true; return; }
      const price = Number(option.dataset.price);
      const saving = Number(option.dataset.saving);
      const state = this.cart ? this.inspect(this.cart) : { count: 0 };
      const base = state.bag ? state.bag.original_price : Number(this.dataset.productPrice);
      const regular = price;
      this.querySelector('[data-regular]').textContent = this.money(regular);
      this.querySelector('[data-offer-price]').textContent = this.money(regular - saving);
      this.querySelector('[data-price-note]').textContent = this.dataset.withLabel;
      this.querySelector('.diya-offer__badge').textContent = this.dataset.savingLabel.replace('[amount]', this.money(saving));
      const image = this.querySelector('img');
      image.src = option.dataset.image;
      image.alt = option.dataset.title;
      const link = this.querySelector('.diya-offer__image-link');
      link.href = option.dataset.url;
      link.setAttribute('aria-label', option.dataset.title);
      if (!DiyaGiftOffer.adding) {
        const total = state.count ? price - saving : base + price - saving;
        this.button.textContent = (state.count ? this.dataset.addLabel : this.dataset.bothLabel).replace('[price]', this.money(total));
      }
    }
    applyCart(cart) {
      this.cart = cart;
      const state = this.inspect(cart);
      const productEligible = this.dataset.placement === 'product' && this.dataset.productAvailable === 'true';
      this.hidden = cart.currency !== 'EUR' || state.addon || !(state.count || productEligible) || !this.catalog.length;
      this.button.disabled = DiyaGiftOffer.adding || this.hidden;
      this.matchPrint();
      this.updateDisplay();
    }
    async refresh() {
      try { this.applyCart(await DiyaGiftOffer.getCart()); } catch { this.hidden = true; }
    }
    async add(event) {
      event.preventDefault();
      if (DiyaGiftOffer.adding) return;
      DiyaGiftOffer.adding = true;
      this.button.disabled = true;
      this.button.textContent = this.dataset.addingLabel;
      this.error.hidden = true;
      try {
        const cart = await DiyaGiftOffer.getCart();
        const state = this.inspect(cart);
        if (cart.currency !== 'EUR') throw new Error(this.dataset.requiredLabel);
        if (state.addon) throw new Error(this.dataset.conflictLabel);
        const items = [];
        if (!state.count) {
          if (this.dataset.placement !== 'product' || this.dataset.productAvailable !== 'true') throw new Error(this.dataset.requiredLabel);
          items.push({ id: Number(this.dataset.productVariant), quantity: 1 });
        }
        const option = this.select.selectedOptions[0];
        if (!option) throw new Error(this.dataset.errorLabel);
        items.push({ id: Number(option.value), quantity: 1 });
        const cartUI = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
        const body = { items, sections_url: window.location.pathname };
        if (cartUI) {
          body.sections = cartUI.getSectionsToRender().map(section => section.id);
          cartUI.setActiveElement(document.querySelector('#cart-icon-bubble'));
        }
        const response = await fetch(window.Shopify.routes.root + 'cart/add.js', {
          method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify(body)
        });
        const result = await response.json();
        if (!response.ok || result.status) throw new Error(result.description || this.dataset.errorLabel);
        if (document.querySelector('#main-cart-items')) { window.location.reload(); return; }
        if (cartUI && result.sections) {
          try { cartUI.renderContents({ ...result.items[result.items.length - 1], sections: result.sections }); }
          catch { window.location.assign(window.Shopify.routes.root + 'cart'); return; }
        } else { window.location.assign(window.Shopify.routes.root + 'cart'); return; }
        publish(PUB_SUB_EVENTS.cartUpdate, { source: 'diya-gift-offer' });
      } catch (error) {
        this.error.textContent = error.message || this.dataset.errorLabel;
        this.error.hidden = false;
      } finally {
        DiyaGiftOffer.adding = false;
        document.querySelectorAll('diya-gift-offer').forEach(offer => offer.refresh());
      }
    }
  }
  customElements.define('diya-gift-offer', DiyaGiftOffer);
}
  } catch(e) { console.error(e); }
})();

})();
